import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useCleanQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const cleanQueryParams = useCallback((allowedParams: string[]) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const newParams = new URLSearchParams();
    allowedParams.forEach((key) => {
      if (params.has(key)) {
        newParams.set(key, params.get(key) as string);
      }
    });

    const newUrl = `${url.pathname}${newParams.toString() ? "?" + newParams.toString() : ""}`;
    if (newUrl !== location.pathname + location.search) {
      navigate(newUrl, { replace: true });
    }
  }, [location, navigate]);

  return cleanQueryParams;
};

export default useCleanQueryParams;
